<div class="logo-container">
	<img class="img" src="/assets/img/dropbox-sign-plus-procore.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- SCREEN 2 -->
<div [ngClass]="{'hidden': loading }">
	<div class="wizard-title">CHOOSE SUBSCRIPTION TYPE</div>
	<div class="form-container">
		<div class="form-text-container">Would you like to start a trial or purchase a subscription?</div>
		<div class="form-text-container">The trial is 7-days, no-obligation, and includes 3 free signatures. It can run alongside existing solutions and be enabled system-wide or for a single project.</div>
	</div>
	<div class="button-container">
		<button (click)="selectTrial()">Trial</button>
		<button (click)="selectPurchase()">Purchase</button>
	</div>
</div>